import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  ntierProjectId: null,
  verifyingSuppliers: {}, // Keyed by SKU-Node ID or similar unique key
  valueChainFiltersByKey: {},
  projectsTableFilterModel: null,
  projectDetailsSkuGridFilterModel: null,
}

export function mergeNtierVcFilters(stored) {
  const defaults = {
    flaggedOnly: false,
    lowConfidenceOnly: false,
    confidenceTierMask: { low: false, med: false, high: false },
    watchlistEnabled: false,
    watchlistCountries: [],
    geoCountry: [],
    geoRegion: [],
    supplierRoles: [],
  }
  if (!stored || typeof stored !== 'object') return defaults
  return {
    ...defaults,
    ...stored,
    confidenceTierMask: { ...defaults.confidenceTierMask, ...(stored.confidenceTierMask || {}) },
    geoCountry: Array.isArray(stored.geoCountry) ? [...stored.geoCountry] : defaults.geoCountry,
    geoRegion: Array.isArray(stored.geoRegion) ? [...stored.geoRegion] : defaults.geoRegion,
    supplierRoles: Array.isArray(stored.supplierRoles)
      ? [...stored.supplierRoles]
      : defaults.supplierRoles,
    watchlistCountries: Array.isArray(stored.watchlistCountries)
      ? [...stored.watchlistCountries]
      : defaults.watchlistCountries,
  }
}

export function buildNtierVcFilterStorageKey(projectId, skuId, viewedVersion) {
  const pid = projectId == null ? '' : String(projectId).trim()
  if (!pid || skuId == null || skuId === '') return null
  return `${pid}\u0001${String(skuId)}\u0001${String(viewedVersion ?? '')}`
}

export const ntierSlice = createSlice({
  name: 'ntier',
  initialState,
  reducers: {
    setNtierProjectId: (state, action) => {
      state.ntierProjectId = action.payload
    },
    resetNtierProject: (state) => {
      state.ntierProjectId = null
      state.verifyingSuppliers = {}
      state.valueChainFiltersByKey = {}
    },
    setSupplierVerifying: (state, action) => {
      const { id, isVerifying } = action.payload
      if (!state.verifyingSuppliers) {
        state.verifyingSuppliers = {}
      }
      if (isVerifying) {
        state.verifyingSuppliers[id] = true
      } else if (state.verifyingSuppliers[id]) {
        delete state.verifyingSuppliers[id]
      }
    },
    setNtierValueChainFiltersForKey: (state, action) => {
      const { key, filters } = action.payload || {}
      if (!key || !filters || typeof filters !== 'object') return
      if (!state.valueChainFiltersByKey) state.valueChainFiltersByKey = {}
      state.valueChainFiltersByKey[key] = filters
    },
    setProjectsTableFilterModel: (state, action) => {
      state.projectsTableFilterModel = action.payload
    },
    setProjectDetailsSkuGridFilterModel: (state, action) => {
      state.projectDetailsSkuGridFilterModel = action.payload
    },
  },
})

export const {
  setNtierProjectId,
  resetNtierProject,
  setSupplierVerifying,
  setNtierValueChainFiltersForKey,
  setProjectsTableFilterModel,
  setProjectDetailsSkuGridFilterModel,
} = ntierSlice.actions

export default ntierSlice.reducer
